import Vue from 'vue'
import App from './App'
import router from './router'
// import 'bulma/css/bulma.css'
import VueLazyload from 'vue-lazyload'
import VueAnalytics from 'vue-analytics'

Vue.use(VueLazyload)

Vue.use(VueAnalytics, {
  id: 'UA-81869406-3',
  router
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js